import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/auth',
      name: 'auth',
      component: () => import(/* webpackChunkName: "main" */ './modules/Auth/_views/Auth.vue'),
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import(/* webpackChunkName: "main" */ './modules/Auth/_views/Login.vue'),
        },
      ],
    },
    {
      path: '',
      name: '',
      component: () => import(/* webpackChunkName: "main" */ './views/Panel.vue'),
      // meta: { auth: { roles: 'admin', redirect: { name: 'default' }, forbiddenRedirect: '/403' } },
      meta: { auth: true },
      children: [
        {
          path: '/',
          name: 'home',
          component: Home,
        },
        {
          path: '/customer-group',
          name: 'customer-group',
          component: () => import(/* webpackChunkName: "main" */ './modules/CustomerGroup/_views/CustomerGroup.vue'),
          // meta: { auth: ['admin'] },
        },
        {
          path: '/payment-type',
          name: 'payment-type',
          component: () => import(/* webpackChunkName: "main" */ './modules/PaymentType/_views/PaymentType.vue'),
        },
        {
          path: '/order-status',
          name: 'order-status',
          component: () => import(/* webpackChunkName: "main" */ './modules/OrderStatus/_views/OrderStatus.vue'),
        },
        {
          path: '/set-order-status/:code',
          name: 'set-order-status',
          component: () => import(/* webpackChunkName: "main" */ './modules/OrderStatus/_views/SetStatus.vue'),
        },
        {
          path: '/panel-user',
          name: 'panel-user',
          component: () => import(/* webpackChunkName: "main" */ './modules/PanelUser/_views/List.vue'),
        },
        {
          path: '/role',
          name: 'role',
          component: () => import(/* webpackChunkName: "main" */ './modules/Role/_views/List.vue'),
        },
        {
          path: '/price-list/:id',
          name: 'price-list',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerPriceList/_views/PartnerPriceList.vue'),
        },
        {
          path: '/tour/:id',
          name: 'tour',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerTour/_views/PartnerTour.vue'),
        },
        {
          path: '/price/:partnerGroupId/:paymentTypeId',
          name: 'price',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerPrice/_views/PartnerPrice.vue'),
        },
        {
          path: '/partner-list/:partnerGroupId',
          name: 'partner-list',
          component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/PartnerList.vue'),
        },
        {
          path: '/partner-search',
          name: 'partner-search',
          component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/PartnerSearch.vue'),
        },
        {
          path: '/inactive-customers',
          name: 'inactive-customers',
          component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/InactiveCustomers.vue'),
        },
        {
          path: '/customer-list',
          name: 'customer-list',
          component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/CustomerList.vue'),
        },
        {
          path: 'customer',
          name: 'customer-wrapper',
          component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/CustomerWrapper.vue'),
          // meta: { auth: { roles: 'admin', redirect: { name: 'default' }, forbiddenRedirect: '/403' } },
          meta: { auth: true },
          children: [
            {
              path: '/partner/:id',
              name: 'partner',
              component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/Partner.vue'),
            },
            {
              path: '/partner/:id/orders',
              name: 'customer-orders',
              component: () => import(/* webpackChunkName: "main" */ './modules/Customer/_views/CustomerOrders.vue'),
            },
          ],
        },
        {
          path: '/order-table-list',
          name: 'order-table-list',
          component: () => import(/* webpackChunkName: "main" */ './modules/Order/_views/OrderTableList.vue'),
        },
        {
          path: '/order-edit/:orderId',
          name: 'order-edit',
          component: () => import(/* webpackChunkName: "main" */ './modules/OrderEdit/_views/OrderEdit.vue'),
        },
        {
          path: '/order-info/:orderId',
          name: 'order-info',
          component: () => import(/* webpackChunkName: "main" */ './modules/Order/_views/OrderInfo.vue'),
        },
        {
          path: '/order-create',
          name: 'order-create',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerOrder/_views/OrderForm.vue'),
        },
        {
          path: '/partner-dispatch-form',
          name: 'partner-dispatch-form',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerDispatch/_views/PartnerDispatchForm.vue'),
        },
        {
          path: '/partner-dispatch-orders',
          name: 'partner-dispatch-orders',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerDispatch/_views/PartnerDispatchOrders.vue'),
        },
        {
          path: '/partner-order',
          name: 'partner-order',
          component: () => import(/* webpackChunkName: "main" */ './modules/PartnerOrder/_views/List.vue'),
        },
        {
          path: '/late-dispatched',
          name: 'late-dispatched',
          component: () => import(/* webpackChunkName: "main" */ './modules/LateDispatched/_views/List.vue'),
        },
        {
          path: '/delivery',
          name: 'delivery',
          component: () => import(/* webpackChunkName: "main" */ './modules/Delivery/_views/CreateDeliveryCollection.vue'),
        },
        {
          path: '/undelivered',
          name: 'undelivered',
          component: () => import(/* webpackChunkName: "main" */ './modules/Delivery/_views/Undelivered.vue'),
        },
        {
          path: '/debt/:tourId?',
          name: 'debt',
          component: () => import(/* webpackChunkName: "main" */ './modules/Debt/_views/DebtTourStats.vue'),
        },
        {
          path: '/debt-point-stats/:pointId?',
          name: 'debt-point-stats',
          component: () => import(/* webpackChunkName: "main" */ './modules/Debt/_views/DebtPointStats.vue'),
        },
        {
          path: '/waybills',
          name: 'waybills',
          component: () => import(/* webpackChunkName: "main" */ './modules/Waybills/_views/PrintDeliveryCollection.vue'),
        },
        {
          path: '/print-delivery',
          name: 'print-delivery',
          component: () => import(/* webpackChunkName: "main" */ './modules/Delivery/_views/PrintDeliveryCollection.vue'),
        },
        {
          path: '/unassigned-delivery-orders',
          name: 'unassigned-delivery-orders',
          component: () => import(/* webpackChunkName: "main" */ './modules/Delivery/_views/UnassignedDeliveryOrders.vue'),
        },
        {
          path: '/book-delivery',
          name: 'book-delivery',
          component: () => import(/* webpackChunkName: "main" */ './modules/BookDelivery/_views/BookDelivery.vue'),
        },
        {
          path: '/route',
          name: 'route',
          component: () => import(/* webpackChunkName: "main" */ './modules/Route/_views/List.vue'),
        },
        {
          path: '/flow',
          name: 'flow',
          component: () => import(/* webpackChunkName: "main" */ './modules/Flow/_views/List.vue'),
        },
        {
          path: '/current-report',
          name: 'current-report',
          component: () => import(/* webpackChunkName: "main" */ './modules/Flow/_views/DayReport.vue'),
        },
        {
          path: '/day-report',
          name: 'day-report',
          component: () => import(/* webpackChunkName: "main" */ './modules/Stats/_views/DayReport.vue'),
        },
        {
          path: '/day-report2',
          name: 'day-report2',
          component: () => import(/* webpackChunkName: "main" */ './modules/Stats/_views/DayReport2.vue'),
        },
        {
          path: '/stats4',
          name: 'stats4',
          component: () => import(/* webpackChunkName: "main" */ './modules/Stats/_views/Stats4.vue'),
        },
        {
          path: '/stats5',
          name: 'stats5',
          component: () => import(/* webpackChunkName: "main" */ './modules/Stats/_views/Stats5.vue'),
        },
        {
          path: '/expense-settings',
          name: 'expense-settings',
          component: () => import(/* webpackChunkName: "main" */ './modules/ExpenseSettings/_views/ExpenseSettings.vue'),
        },
        {
          path: '/expense-report',
          name: 'expense-report',
          component: () => import(/* webpackChunkName: "main" */ './modules/Flow/_views/ExpenseReport.vue'),
        },
        {
          path: '/audit-customer-list',
          name: 'audit-customer-list',
          component: () => import(/* webpackChunkName: "main" */ './modules/Audit/_views/CustomerList.vue'),
        },
        {
          path: '/audit-super-customer-list',
          name: 'audit-super-customer-list',
          component: () => import(/* webpackChunkName: "main" */ './modules/AuditSuper/_views/CustomerList.vue'),
        },
      ],
    },

  ],
});
